import { SearchPilotResult, SearchPilotSchema } from "./searchPilotSchema";
import { Logger } from "pino";

/**
 * Reads the base64 string, decodes and validates it, and returns the parsed object.
 * Returns `null` if the string is missing, malformed, or fails validation.
 */
export function parseSearchPilotHeader(
  searchPilotHeader: string | undefined,
  logger?: Logger,
): SearchPilotResult | undefined {
  try {
    if (!searchPilotHeader) return undefined;

    const json: unknown = JSON.parse(base64Decode(searchPilotHeader));

    const parsedJson = SearchPilotSchema.safeParse(json);
    if (parsedJson.error) {
      logger?.warn(
        { json, validation_errors: parsedJson.error.issues },
        "SearchPilot header failed validation",
      );
      return undefined;
    }
    return parsedJson.data;
  } catch (error) {
    logger?.warn(error, "Failed to parse SearchPilot header:");
    return undefined;
  }
}

function base64Decode(input: string) {
  return Buffer.from(input, "base64").toString("utf8");
}
